import PhoneInput from 'components/Inputs/PhoneInput'
import MainButton from 'components/Buttons/MainButton'
import submitOnEnter from 'utils/submitOnEnter'
import ownerDataValidator from 'validators/ownerDataValidator'
import { MdNavigateNext } from 'react-icons/md'
import { Formik } from 'formik'

import {
  Form,
  Row,
  SubTitle,
  FormField,
  WarningText,
  Input
} from '../styles'

export default function OwnerDataForm ({
  businessData = {},
  onFormSubmitted: handleFormSubmitted = () => null
}) {
  return (
    <Formik
      validationSchema={ownerDataValidator}
      initialValues={{
        'owner': businessData.owner,
        'owner_email': businessData.owner_email,
        'owner_phone': businessData.owner_phone
      }}
      onSubmit={values => handleFormSubmitted (values)}
    >
      {({
        values,
        errors,
        touched,
        setFieldValue,
        setFieldTouched,
        handleChange,
        handleBlur,
        handleSubmit
      }) => (
        <Form onKeyDown={submitOnEnter(handleSubmit)} style={{ width: 400 }}>
          <SubTitle>Dados do responsável</SubTitle>
          <Row>
            <FormField>
              <Input
                placeholder='Nome completo do responsável'
                value={values.owner}
                onChange={handleChange ('owner')}
                onBlur={handleBlur ('owner')}
              />
              {touched.owner && errors.owner && (
                <WarningText>{errors.owner}</WarningText>
              )}
            </FormField>
          </Row>
          <Row>
            <FormField>
              <Input
                type='email'
                placeholder='E-mail do responsável'
                value={values.owner_email}
                onChange={handleChange ('owner_email')}
                onBlur={handleBlur ('owner_email')}
              />
              {touched.owner_email && errors.owner_email && (
                <WarningText>{errors.owner_email}</WarningText>
              )}
            </FormField>
          </Row>
          <Row>
            <FormField>
              <PhoneInput
                name='owner_phone'
                placeholder='Celular do responsável'
                value={values.owner_phone}
                onChange={setFieldValue}
                onBlur={setFieldTouched}
              />
              {touched.owner_phone && errors.owner_phone && (
                <WarningText>{errors.owner_phone}</WarningText>
              )}
            </FormField>
          </Row>
          <MainButton
            leftIcon={<MdNavigateNext size={30}/>}
            aria-label='Próximo'
            onClick={handleSubmit}
            width={60}
          />
        </Form>
      )}
    </Formik>
  )
}
